export default __webpack_public_path__ + "static/media/screen19.c7e61fd0.svg";